import * as Sentry from '@sentry/react';
import React from 'react';

import { FallbackComponent } from 'client-web-sdk';

import FullscreenFrame from 'src/components/FullscreenFrame';

type Props = React.PropsWithChildren<{}>;

export default function ErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <FullscreenFrame>
          <FallbackComponent error={error} />
        </FullscreenFrame>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
